/* eslint-disable prefer-template */
'use strict';

var fragt = fragt || {};

fragt.tariffs = fragt.tariffs || new function () {

    var terminal,
        terminalCode,
        currTerminal,
        generatePdfBtn,
        tariffsDateField,
        tariffsResults,
        serviceFeeBtn,
        feesForm,
        serviceFeeSelect,
        zipcodeSelect,
        zipcodesWrap,
        feePriceDates,
        errorElem,
        requesting = false;

    // Function saved for possible use later
    //
    // function reformatSelectorDates(selectElem) {
    //     if (window.moment) {
    //         var dateOptions = selectElem.querySelectorAll('option');
    //         var earlierDate;
    //         for (var d = 0; d < dateOptions.length; d++) {
    //             var option = dateOptions[d];
    //             var newFormat = window.moment(option.innerText).format("LL");

    //             option.textContent = d != 0 ? newFormat + " til " + earlierDate : newFormat;

    //             earlierDate = newFormat;
    //         }
    //     }
    // }

    /**
     *
     * @param {string} date - date as string (possible formats: yyyy-mm-dd or yyyymmdd or yyyymm)
     * @param {string[]} versions - array of dates formated as 'yyyymm'
     */
    function returnApplicableDate(date, versions) {
        var ym = date.replace('-', '').substring(0, 6);

        // Make sure dates are sorted with decending values
        versions.sort().reverse();
        var earliestDate = versions[versions.length - 1];

        if (ym >= versions[0]) {
            return versions[0];
        } else if (ym == earliestDate) {
            return earliestDate;
        } else if (ym < earliestDate) {
            errorElem.classList.add('active');
            errorElem.classList.add('active--too-old');
            return earliestDate;
        } else {
            for (var v = 0; v < versions.length; v++) {

                if (ym >= versions[v]) {
                    return versions[v];
                }
            }
        }
    }

    this.fetchTerminalData = function (id) {
        var templatePath = '/selvbetjening/?alttemplate=locationDataById&locationId=' + id;
        var tariffsInfo = document.getElementById('terminalInfo');

        if (tariffsInfo) {
            // Set loading state on result containers
            tariffsInfo.parentNode.classList.add('loading');
            tariffsResults.classList.remove('active--service-fee');

            var xhr = new XMLHttpRequest();
            xhr.open('POST', templatePath, true);
            xhr.setRequestHeader('content-type', 'html/text; charset=utf-8');
            xhr.ResponseType = 'document';
            xhr.onload = function () {
                tariffsInfo.parentNode.classList.remove('loading');
                requesting = false;
                generatePdfBtn.disabled = false;

                if (xhr.readyState === 4) {
                    if (xhr.status === 200 || xhr.status === 404) {
                        if (xhr.status === 200) {
                            tariffsInfo.innerHTML = xhr.responseText;
                        }
                        if (xhr.status === 404) {
                            tariffsInfo.innerHTML =
                                '<div class="ajax-content error-msg">Kunne ikke finde terminal information</br></br>' +
                                xhr.status +
                                ' ' +
                                xhr.statusText +
                                '</br ></br > <button class="button button--enter" onclick="location.reload();"> Genindl&aelig;s siden </button></div >';
                        }
                    } else {
                        console.warn(xhr.responseText);
                    }
                } else {
                    console.warn("Der skete med servicen: '/selvbetjening/?alttemplate=locationDataById&locationId'\n", xhr.responseText);
                }
            };
            xhr.onerror = function () {
                console.warn('Error with fragt.tariffs.fetchTerminalData');
            };
            xhr.send();
        }
    };

    this.generatePdfLinks = function (e) {
        e.preventDefault();

        var zipcode = document.getElementById('tariffsZipcode').value;
        var dato = tariffsDateField.getAttribute('data-date');
        var versions = tariffsDateField.parentNode.getAttribute('data-versions');
        var zipcodesWithoutTTD = ['5000','5100','5200','5210','5220','5230','5240','5250','5260','5270','5290','5300','5320','5330','5350','5370','5380','5390','5400','5450','5462','5463','5464','5466','5471','5474','5485','5491','5492','5500','5540','5550','5560','5580','5591','5592','5600','5601','5602','5603','5610','5620','5631','5642','5672','5683','5690','5700','5750','5762','5771','5772','5792','5800','5853','5854','5856','5863','5871','5874','5881','5882','5883','5884','5892','5900','5932','5935','5943','5953','5960','5965','5970','5985','6000','6040','6051','6052','6064','6070','6091','6092','6093','6094','6100','6200','6210','6230','6240','6261','6270','6280','6300','6310','6320','6330','6340','6360','6372','6392','6400','6430','6440','6470','6500','6510','6520','6534','6535','6541','6560','6580','6600','6621','6622','6623','6630','6640','6650','6660','6670','6682','6683','6690','6700','6701','6705','6710','6715','6720','6731','6740','6752','6753','6760','6771','6780','6792','6799','7000','7080','7100','7120','7130','7140','7150','7160','7171','7173','7182','7183','7184','7190','7200','7250','7300','7321','7323','7330','7361','7362','7400','7430','7441','7442','7451','7470','7480','7490','7540','7700','7730','7741','7742','7752','7755','7760','7770','7790','7800','7840','7850','7860','7870','7884','7900','7950','7960','7970','7980','7990','8721','8722','8723','8762','8763','8781','8783','8789','9000','9020','9100','9200','9210','9220','9230','9240','9260','9270','9280','9293','9300','9310','9320','9330','9340','9352','9362','9370','9380','9381','9382','9400','9430','9440','9460','9480','9490','9492','9493','9510','9520','9530','9541','9574','9575','9600','9610','9620','9631','9632','9640','9670','9681','9690','9700','9740','9750','9760','9800','9830','9850','9870','9881','9900','9940','9970','9981','9982','9990'];
        var zipcodeGroups = window.takster.zipcodeGroups || [];
        var terminals = window.takster.terminals || [];
        var groupFound = false;

        errorElem.classList.remove('active');
        errorElem.classList.remove('active--too-old');

        if (versions) {
            versions = versions.split(',');
        }

        // Validation of values
        if (!dato) {
            tariffsDateField.focus();
            return;
        }

        if (zipcode.length != 4) {
            errorElem.classList.add('active');

            document.getElementById('tariffsZipcode').focus();
            return;
        }

        if (!zipcodeGroups.length) {
            console.warn('Defination af postnummer-grupper mangler for takster. (window.takster.zipcodeGroups er muligvis ikke sat)');
            return;
        }

        if (!requesting) {
            requesting = true;
            generatePdfBtn.disabled = true;

            tariffsResults.classList.remove('active--service-fee');
            tariffsResults.classList.remove('show-links');

            for (var x = 0; x < zipcodeGroups.length; x++) {
                if (zipcodeGroups[x].indexOf(zipcode) !== -1) {
                    var zipcodeGroup = ('0' + x).slice(-2); // Fix to ensure 2 max digits (ex. 011 -> 11)
                    var ym = returnApplicableDate(dato, versions);

                    if (terminals.length) {
                        for (var t = 0; t < terminals.length; t++) {
                            if (terminals[t].zips.indexOf(zipcodeGroup) !== -1) {
                                terminal = terminals[t].id;
                                terminalCode = terminals[t].code;
                                break;
                            }
                        }
                    } else {
                        console.warn('Definition af tilgængelige terminaler for takster mangler. (window.takster.terminals er muligvis ikke sat) eller postnr grupper mangler på');
                    }

                    if (terminal && terminal != currTerminal) {
                        currTerminal = terminal;
                        fragt.tariffs.fetchTerminalData(terminal);
                    } else {
                        requesting = false;
                        generatePdfBtn.disabled = false;
                    }

                    // Clean lists
                    document.getElementById('DDDK').innerHTML = '';
                    document.getElementById('TDDK').innerHTML = '';
                    document.getElementById('DDSS').innerHTML = '';
                    document.getElementById('TDSS').innerHTML = '';
                    document.getElementById('DDNO').innerHTML = '';
                    document.getElementById('TDNO').innerHTML = '';

                    var filenameDD = ym + '-' + zipcodeGroup;
                    var filenameTD = ym + '-' + terminalCode;
                    var pdfFolderPath = '/takster/';
                    var editDate = new Date().getTime();

                    document.getElementById('overskriftDK').innerHTML = 'Forsendelser fra <b>' + zipcode + '</b> til <b>Danmark</b>';
                    document.getElementById('overskriftSS').innerHTML = 'Forsendelser fra <b>' + zipcode + '</b> til <b>Sverige</b> eller <b>Slesvig-Holsten</b>';
                    document.getElementById('overskriftNO').innerHTML = 'Fra <b>' + zipcode + '</b> til <b>Norge</b>';

                    var dddk = '<a href="' + pdfFolderPath + filenameDD + '-DK-DD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Dør-Dør: Se takstblad</a>';
                    document.getElementById('DDDK').innerHTML = dddk;

                    // Only show Door to Door (DD) tariffs for Norway & Sweden if the zipcode isn't part of the zipcode group with no. 12
                    if (zipcodeGroup != '12') {
                        var ddss = '<a href="' + pdfFolderPath + filenameDD + '-SS-DD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Dør-Dør: Se takstblad</a>';
                        var ddno = '<a href="' + pdfFolderPath + filenameDD + '-NO-DD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Dør-Dør: Se takstblad</a>';

                        document.getElementById('DDSS').innerHTML = ddss;
                        document.getElementById('DDNO').innerHTML = ddno;
                    }

                    // Only show Terminal to Door (TD) tariffs if the zipcode isn't part of the excluded list
                    if (zipcodesWithoutTTD.indexOf(zipcode) === -1) {
                        var tddk = '<a href="' + pdfFolderPath + filenameTD + '-DK-TD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Terminal-Dør: Se takstblad</a>';
                        var tdss = '<a href="' + pdfFolderPath + filenameTD + '-SS-TD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Terminal-Dør: Se takstblad </a>';
                        var tdno = '<a href="' + pdfFolderPath + filenameTD + '-NO-TD.pdf?v=' + editDate + '" target="_blank" rel="noopener">Terminal-Dør: Se takstblad </a>';

                        document.getElementById('TDDK').innerHTML = tddk;
                        document.getElementById('TDSS').innerHTML = tdss;
                        document.getElementById('TDNO').innerHTML = tdno;
                    }

                    tariffsResults.classList.add('active');

                    setTimeout(function () {
                        tariffsResults.classList.add('show-links');
                    }, 300);

                    groupFound = true;

                    break;
                }
            }

            if (groupFound === false) {
                errorElem.classList.add('active');
                document.getElementById('tariffsResults').classList.remove('active');
                generatePdfBtn.disabled = false;
                requesting = false;
            }
        }

    };

    this.fetchFeeDates = function (e) {
        e.preventDefault();

        var nodeId;

        if (!requesting) {
            requesting = true;
            serviceFeeBtn.disabled = true;

            if (this.tagName == 'SELECT') {
                var zipOption = serviceFeeSelect.querySelector('[value="' + serviceFeeSelect.value + '"]');
                nodeId = this.value;

                if (zipcodesWrap) {
                    if (zipOption && zipOption.hasAttribute('data-fee-pr-zip')) {
                        zipcodesWrap.classList.remove('hidden');
                        nodeId = zipcodeSelect.value;
                    } else {
                        zipcodesWrap.classList.add('hidden');
                    }
                }
            } else {
                var dateStr = document.getElementById('feeDate').getAttribute('data-date');
                var dates = Object.keys(feePriceDates);
                var priceDate = returnApplicableDate(dateStr, dates);

                nodeId = feePriceDates[priceDate];
            }

            if (nodeId) {
                var getDates = (this.id === 'feeName' || this.id === 'zipcodeInterval') ? this.id : "";
                var paramName = getDates ? 'serviceFeeID' : 'pricePrDateID';
                var templatePath = '/selvbetjening/?alttemplate=servicefeedata&' + paramName + '=' + nodeId;

                if (zipcodesWrap && !zipcodesWrap.classList.contains('hidden')) {
                    templatePath += '&serviceFeePrZipID=' + serviceFeeSelect.value;
                }

                tariffsResults.classList.remove('active');

                // Set loading state on result containers
                feesForm.parentNode.classList.add('loading');

                var xhr = new XMLHttpRequest();
                xhr.open('POST', templatePath, true);
                xhr.setRequestHeader('content-type', 'html/text; charset=utf-8');
                xhr.ResponseType = 'document';
                xhr.onload = function () {
                    feesForm.parentNode.classList.remove('loading');
                    requesting = false;
                    serviceFeeBtn.disabled = false;

                    if (xhr.readyState === 4) {
                        if (xhr.status === 200 || xhr.status === 404) {
                            if (xhr.status === 200) {
                                if (getDates) {
                                    feePriceDates = JSON.parse(xhr.responseText);
                                    var feeDateField = document.getElementById('feeDate');

                                    if (feeDateField) {
                                        tariffsResults.classList.remove('active--service-fee');

                                        if (getDates === 'zipcodeInterval' || zipcodesWrap && zipcodesWrap.classList.contains('hidden')) {
                                            document.getElementById('getServiceFee').click();
                                        }
                                    }
                                } else {
                                    document.getElementById('serviceFeeResults').innerHTML = xhr.responseText;
                                    tariffsResults.classList.add('active--service-fee');
                                }
                            }
                            if (xhr.status === 404) {
                                document.getElementById('serviceFeeResults').innerHTML =
                                    '<div class="ajax-content error-msg">Der er desv&aelig;rre sket en fejl </br></br>' +
                                    xhr.status +
                                    ' ' +
                                    xhr.statusText +
                                    '</br ></br > <button class="button button--enter" onclick="location.reload();"> Genindl&aelig;s siden </button></div >';
                            }
                        } else {
                            console.warn(xhr.responseText);
                        }
                    }
                };
                xhr.onerror = function () {
                    console.warn('Error with fragt.tariffs.fetchFeeDates');
                };
                xhr.send();
            } else {
                requesting = false;
                serviceFeeBtn.disabled = false;
                console.warn('nodeId missing on: ', this);
            }
        }
    };

    this.init = function () {

        generatePdfBtn = document.getElementById('generatePDFLinks');
        tariffsDateField = document.getElementById('tariffsDate');

        if (generatePdfBtn && tariffsDateField) {

            tariffsResults = document.getElementById('tariffsResults');
            zipcodesWrap = document.getElementById('zipcodeIntervals');
            feesForm = document.getElementById('feesForm');

            serviceFeeSelect = document.getElementById('feeName');
            zipcodeSelect = document.getElementById('zipcodeInterval');

            errorElem = document.getElementById('notFoundError');

            generatePdfBtn.addEventListener('click', fragt.tariffs.generatePdfLinks);

            if (serviceFeeSelect) {
                serviceFeeSelect.addEventListener('change', fragt.tariffs.fetchFeeDates);

                if (zipcodeSelect) {
                    zipcodeSelect.addEventListener('change', fragt.tariffs.fetchFeeDates);
                }
            }

            var feeDateField = document.getElementById('feeDate');

            if (feeDateField) {
                feePriceDates = feesForm.getAttribute('data-price-dates') ? JSON.parse(feesForm.getAttribute('data-price-dates')) : {};

                serviceFeeBtn = document.getElementById('getServiceFee');

                if (serviceFeeBtn) {
                    serviceFeeBtn.addEventListener('click', fragt.tariffs.fetchFeeDates);
                }
            }
        }
    };
}();
